import { createContext } from 'react';
import { RestaurantNotificationEventType, IEditScheduledPush } from 'types';

export type TTypeOfEditScheduleModalWindow = null | 'toConfirmFieldsClearing' | 'toConfirmSubmit' | 'success' | 'error';
export interface IInitialFormData {
	schedule: string;
}

export interface IEditScheduleState {
	initialFormData: IInitialFormData | null;
	scheduleID: string;
	pushType: RestaurantNotificationEventType | null;
	schedule: string;
	dataForSubmit: IEditScheduledPush | null;
	typeOfModalWindow: TTypeOfEditScheduleModalWindow;
}

export const editScheduleInitialState: IEditScheduleState = {
	initialFormData: null,
	scheduleID: '',
	pushType: null,
	schedule: '',
	dataForSubmit: null,
	typeOfModalWindow: null,
};

export interface IEditScheduleContext extends IEditScheduleState {
	changeSchedule(value: string): void;
	setDataForSubmit(value: IEditScheduledPush | null): void;
	changeTypeOfModalWindow(value: TTypeOfEditScheduleModalWindow): void;
	resetFields(): void;
}

export const EditScheduleContext = createContext<IEditScheduleContext>({
	changeSchedule: () => undefined,
	setDataForSubmit: () => undefined,
	changeTypeOfModalWindow: () => undefined,
	resetFields: () => undefined,
	...editScheduleInitialState,
});
